export default __webpack_public_path__ + "static/media/Step-1-safari.8f255d7f.mov";